<template>
  <div class="legend-item">
    <span class="legend-icon" :style="{ background: color }"></span>
    <span class="legend-name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  props: ['name', 'color']
}
</script>

<style lang="scss" scoped>
.legend-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  .legend-icon {
    flex-shrink: 0;
    margin-right: 5px;
    width: 8px;
    height: 8px;
  }
  &:not(:first-child) {
    margin-top: 14px;
  }
}
</style>
